import { isEqual } from "lodash";
import { useControlGroup } from "./useControlGroup";
export var useIsSelectedControl = function (value) {
    var selected = useControlGroup().selected;
    return Array.isArray(selected)
        ? selected === null || selected === void 0 ? void 0 : selected.includes(value)
        : isEqual(value, selected);
};
